import React from 'react';

import browse from './browse.svg';
import './SectionTitle.less';

const SectionTitle = (props) => {
    const {title, subtitle, noIcon} = props;

    return (
        <div className="SectionTitle">
            <h2 className="SectionTitle__title">{title}</h2>
            {subtitle && (
                <p className="SectionTitle__subtitle">
                    {!noIcon && (
                        <img src={browse()} className="SectionTitle__icon" />
                    )}{' '}
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default SectionTitle;
